import { CircularProgress, InputAdornment } from "@mui/material"
import { CancelOutlined, CheckCircleFilledRounded } from "@mui-symbols-material/w300"
import type { FC } from "react"
import React from "react"
import type { FieldError } from "react-hook-form"

const ValidationAdornment: FC<{ loading?: boolean; error?: FieldError }> = ({ loading, error }) => (
  <InputAdornment position='end'>
    {loading ? (
      <CircularProgress size={20} />
    ) : error ? (
      <CancelOutlined className='text-secondary' />
    ) : (
      <CheckCircleFilledRounded className='text-tertiary-green-500' />
    )}
  </InputAdornment>
)

export default ValidationAdornment
